import * as React from 'react';
import { ReactComponent as UserIconSVG } from '../../assets/icons/mevo/ic_user.svg';
import IconPattern, { IconProps } from './_IconPattern';

const UserIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={UserIconSVG} variantPlaces={2} {...props} />;
};

export default UserIcon;
